// NewCategory.js
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './NewCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure toastify styles are imported
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
const NewSubCategory = () => {
    const location = useLocation();
    const { selectedCategory } = location.state || {};
    const [name, setName] = useState('');
    const [nameAr, setnameAr] = useState('');
    const [newImage, setNewImage] = useState(null);
    const [NewImageView, setNewImageView] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const handleImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
          const file = event.target.files[0];
          const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
          if (!validTypes.includes(file.type)) {
            toast.error('Please select a valid image file (jpeg, jpg, png).');
            return;
          }
          setNewImage(file); // Store the file object
          setNewImageView(URL.createObjectURL(event.target.files[0]));
        }
      };

    const handleSave = async (e) => {
    console.log("selectedCategory",selectedCategory)

        e.preventDefault();
        setError('')
        if (!name) {
            toast.error('Please enter a category name.');
            return;
        }

        setLoading(true);

        try {
            const token = JSON.parse(localStorage.getItem('token'));
            if (!token) {
                toast.error('You are not authenticated.');
                return;
            }
            const formData = new FormData();
            formData.append('name[en]', name);
            formData.append('name[ar]', nameAr);
            formData.append('photo', newImage);
            formData.append('category_id', selectedCategory);
            
            const response = await fetch(baseUrl + '/categories/subcategories', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'x-api-key': 'web-app',
                    "Authorization": 'Bearer ' + token,
                },
                body: formData,
            });

            const data = await response.json();
            if (response.ok) {
                toast.success('added successfully');
                navigate('/SubCategories');// Redirect to the home page within the root layout
            } else {
                if (data.errors) {
                    if (data.errors.name) {
                        toast.error(data.errors.name[0]);
                    }
                }
            }
        } catch (err) {
            console.log("err", err)
            // Handle network or unexpected errors
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

   

    return (
        <div style={{ width: '100%' }}>
            {loading && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                </div>
            )}


            <h2 style={{ color: "#000", textAlign: 'center' }}>New Sub category</h2>
            <div className="new-category-container">
                <div className="new-category">
                    <div className="new-form-group">
                        <label htmlFor="name">English Name</label>
                        <input
                            style={{ backgroundColor: "#fff", fontSize: 20, width: "70%", color: "#000" }}
                            placeholder='SubCategory english name'
                            required
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="new-form-group">
                        <label htmlFor="name">Arabic Name</label>
                        <input
                            style={{ backgroundColor: "#fff", fontSize: 20, width: "70%", color: "#000" }}
                            placeholder='SubCategory english name'
                            required
                            type="text"
                            id="namear"
                            value={nameAr}
                            onChange={(e) => setnameAr(e.target.value)}
                        />
                    </div>
                    <div className="new-form-group">
                        <label htmlFor="imageUrl">Image</label>
                        <div className="image-preview">
                            <label htmlFor="imageUpload" className="upload-label">
                                {NewImageView ? (
                                    <img src={NewImageView} alt="Category" className="newcategory-image" />
                                ) : (
                                    <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                )}
                            </label>
                            <input
                                required
                                type="file"
                                id="imageUpload"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{ display: 'none' }}
                            />
                        </div>
                    </div>
                    <div className="form-buttons">
                        <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
                        <button onClick={() => navigate('/SubCategories')} style={{ backgroundColor: "#000" }}>Cancel</button>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default NewSubCategory;
